import {
  Button,
  Card,
  CardContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import DeleteIcon from "@mui/icons-material/Delete";
import BusinessIcon from "@mui/icons-material/Business";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";

export default function CardDesktop({
  item,
  openDatei,
  openDetails,
  filter,
  user,
  startDelete,
}) {
  const { t } = useTranslation();

  const shortText = (htmlText, maxLength) => {
    if (!htmlText) return "";

    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const text = doc.body.textContent?.trim() || "";

    return text.length > maxLength
      ? `${text.slice(0, maxLength)}...`
      : text;
  };

  const preview = shortText(item.meldung, 130);

  return (
    <Card
      elevation={0}
      onClick={(e) => openDetails(e, item)}
      sx={{
        cursor: "pointer",
        borderRadius: 2,
        border: 1,
        overflow: "hidden",
        transition: ".18s",
        backgroundColor: "background.paper",

        "&:hover": {
          borderColor: "primary.main",
          boxShadow: "0 6px 20px rgba(0,0,0,.08)",
          transform: "translateY(-1px)",
        },
      }}
    >
      <CardContent
        sx={{
          p: 2,
          "&:last-child": {
            pb: 2,
          },
        }}
      >
        <Stack spacing={1.2}>
          {/* Header */}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
          >
            <Typography
              fontWeight={700}
              sx={{
                flex: 1,
                fontSize: "1.05rem",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {item.betreff?.trim()}
            </Typography>

            <Stack direction="row" spacing={1} alignItems="center">
              {item.datei && (
                <Button
                  size="small"
                  startIcon={<FolderOpenIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    openDatei(e, item.datei);
                  }}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    minWidth: "auto",
                  }}
                >
                  {t("Datei öffnen")}
                </Button>
              )}

              {item?.ersteller === user?.id && (
                <IconButton
                  size="small"
                  color="error"
                  onClick={(e) => {
                    e.stopPropagation();
                    startDelete(e, item);
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            </Stack>
          </Stack>

          {/* Vorschau */}
          {preview && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                lineHeight: 1.45,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {preview}
            </Typography>
          )}

          {/* Infos */}
          <Stack
            direction="row"
            spacing={3}
            flexWrap="wrap"
            alignItems="center"
          >
            {(filter === "Aktiv" || filter === "Inaktiv") && (
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
              >
                <EventOutlinedIcon
                  sx={{
                    fontSize: 15,
                    color: "text.secondary",
                  }}
                />

                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  {item.vondat}
                  {filter !== "Aktiv" &&
                    ` – ${item.bisdat}`}
                </Typography>
              </Stack>
            )}

            <Stack
              direction="row"
              spacing={0.5}
              alignItems="center"
            >
              <BusinessIcon
                sx={{
                  fontSize: 15,
                  color: "text.secondary",
                }}
              />

              <Typography
                variant="caption"
                color="text.secondary"
              >
                {item.mandant}
              </Typography>
            </Stack>

            {item?.erstellerText && (
              <Stack
                direction="row"
                spacing={0.5}
                alignItems="center"
              >
                <PersonOutlineIcon
                  sx={{
                    fontSize: 15,
                    color: "text.secondary",
                  }}
                />

                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  {item.erstellerText}
                </Typography>
              </Stack>
            )}

            <Stack flex={1} />

            <Button
              size="small"
              endIcon={<ArrowForwardIcon />}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                minWidth: "auto",
              }}
            >
              {t("Mehr")}
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}